module.exports = __webpack_public_path__ + "static/media/curdSideWalkupPayLater.960a14b9.png";